function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clamp from 'lodash.clamp';
import GridMouseHandler from "../GridMouseHandler.js";
/* eslint class-methods-use-this: "off" */
class GridVerticalScrollBarMouseHandler extends GridMouseHandler {
  constructor() {
    super(...arguments);
    _defineProperty(this, "dragOffset", void 0);
    // to trigger pointer event blocking
    _defineProperty(this, "cursor", 'default');
  }
  static getTopWithOffsetFromRawTop(grid, rawTop) {
    var theme = grid.getTheme();
    var metrics = grid.metrics,
      metricCalculator = grid.metricCalculator;
    if (!metrics) throw new Error('metrics not set');
    if (theme.scrollSnapToRow) {
      var _top = Math.round(rawTop);
      var _topOffset = 0;
      return {
        top: _top,
        topOffset: _topOffset
      };
    }
    var top = Math.floor(rawTop);
    var topOffsetPercent = rawTop - top;
    var rowHeight = metrics.allRowHeights.get(top);
    if (rowHeight == null) {
      var metricState = grid.getMetricState();
      rowHeight = metricCalculator.getVisibleRowHeight(top, metricState);
    }
    var topOffset = rowHeight * topOffsetPercent;
    return {
      top,
      topOffset
    };
  }
  isInScrollBar(gridPoint, grid) {
    var theme = grid.getTheme();
    var scrollBarSize = theme.scrollBarSize,
      scrollBarHoverSize = theme.scrollBarHoverSize;
    var metrics = grid.metrics;
    if (!metrics) throw new Error('metrics not set');
    var x = gridPoint.x,
      y = gridPoint.y;
    var barTop = metrics.barTop,
      barHeight = metrics.barHeight,
      width = metrics.width,
      hasVerticalBar = metrics.hasVerticalBar;
    return hasVerticalBar && scrollBarSize > 0 && x >= width - scrollBarHoverSize && x < width && y > barTop && y < barTop + barHeight;
  }
  getTopWithOffset(gridPoint, grid) {
    var _this$dragOffset;
    var metrics = grid.metrics;
    if (!metrics) throw new Error('metrics not set');
    var y = gridPoint.y;
    var barHeight = metrics.barHeight,
      handleHeight = metrics.handleHeight,
      lastTop = metrics.lastTop,
      barTop = metrics.barTop,
      rowCount = metrics.rowCount,
      scrollableContentHeight = metrics.scrollableContentHeight,
      scrollableViewportHeight = metrics.scrollableViewportHeight;
    var mouseBarY = y - barTop;
    var scrollPercent = clamp((mouseBarY - ((_this$dragOffset = this.dragOffset) !== null && _this$dragOffset !== void 0 ? _this$dragOffset : 0)) / (barHeight - handleHeight), 0, 1);
    if (rowCount === 1) {
      return {
        top: 0,
        topOffset: scrollPercent * (scrollableContentHeight - scrollableViewportHeight)
      };
    }
    var rawTop = scrollPercent * lastTop;
    return GridVerticalScrollBarMouseHandler.getTopWithOffsetFromRawTop(grid, rawTop);
  }
  onDown(gridPoint, grid) {
    var metrics = grid.metrics;
    if (!metrics) throw new Error('metrics not set');
    var y = gridPoint.y;
    var handleHeight = metrics.handleHeight,
      barTop = metrics.barTop,
      scrollY = metrics.scrollY;
    if (!this.isInScrollBar(gridPoint, grid)) {
      return false;
    }
    var mouseBarY = y - barTop;
    if (mouseBarY >= scrollY && mouseBarY <= scrollY + handleHeight) {
      // Grabbed the vertical handle
      this.dragOffset = mouseBarY - scrollY;
      grid.setState({
        isDraggingVerticalScrollBar: true
      });
    } else {
      // clicked elsewhere in bar
      this.dragOffset = 0;
      var _this$getTopWithOffse = this.getTopWithOffset(gridPoint, grid),
        newTop = _this$getTopWithOffse.top,
        newTopOffset = _this$getTopWithOffse.topOffset;
      grid.setViewState({
        top: newTop,
        topOffset: newTopOffset,
        isDraggingVerticalScrollBar: true,
        isDragging: true
      });
    }
    return true;
  }
  onMove(gridPoint, grid) {
    return this.isInScrollBar(gridPoint, grid);
  }
  onDrag(gridPoint, grid) {
    if (this.dragOffset != null) {
      var _this$getTopWithOffse2 = this.getTopWithOffset(gridPoint, grid),
        newTop = _this$getTopWithOffse2.top,
        newTopOffset = _this$getTopWithOffse2.topOffset;
      grid.setViewState({
        top: newTop,
        topOffset: newTopOffset,
        isDraggingVerticalScrollBar: true,
        isDragging: true
      });
      return true;
    }
    return false;
  }
  onUp(gridPoint, grid) {
    if (this.dragOffset !== undefined) {
      this.dragOffset = undefined;
      grid.setState({
        isDraggingVerticalScrollBar: false,
        isDragging: false
      });
    }
    return this.isInScrollBar(gridPoint, grid);
  }
  onClick(gridPoint, grid) {
    return this.isInScrollBar(gridPoint, grid);
  }
}
export default GridVerticalScrollBarMouseHandler;
//# sourceMappingURL=GridVerticalScrollBarMouseHandler.js.map